<template>
  <div>
    <el-card>
      <app-breadcrumb :items="items"></app-breadcrumb>
    </el-card>
    <br />
    <el-card>
      <h2 class="title">Documentos</h2>
      <br />
      <h5 v-if="reloadComponent==0">
        <i class="el-icon-loading"></i> Espere a que termine de cargar los datos.
      </h5>
      <app-table-paginate
        v-if="reloadComponent!=0"
        :key="reloadComponent"
        v-show="tableShowGroup"
        routeDelete="no"
        selection="no"
        :tableQuery="getList"
        :tableColumns="tableColumns"
        :limit="limit"
        :search="false"
        :noDisplayActions="true"
        :expand="true"
        :expandData="'usuarios'"
        :expandColumns="expandColumns"
        :previewModal="false"
        :displayAccionesExpandTable="false"
      ></app-table-paginate>
    </el-card>
    <br />
  </div>
</template>

<script>
import { API_UPLOADS } from "@/common/config";

import ApiService from "@/common/api.service";
import tablaConPaginador from "@/components/_commons/tablaConPaginador";
import breadcrumb from "@/components/_commons/breadcrumb";
export default {
  name: "HistoricoAccesoDocumentos",
  components: {
    "app-table-paginate": tablaConPaginador,
    "app-breadcrumb": breadcrumb
  },
  created() {
    this.get();
  },
  data() {
    return {
      id_notificacion: 0,
      showUsersModal: false,
      loader: 0,
      reloadComponent: 0,
      width: "100%",
      height: "400",
      dataFormat: "json",
      dataSource: {
        chart: {
          caption: "Agrupación de notificaciones por escritorio",
          yaxismaxvalue: this.max,
          theme: "fusion",
          plotToolText: "<b>$label</b><br>$seriesName: <b>$dataValue</b>"
        },
        categories: [
          {
            category: null
          }
        ],
        dataset: null
      },
      dataSource2: {
        chart: {
          bgColor: "FFFFFF",
          caption: "Notificaciones",
          plottooltext: "<b>$percentValue</b> de notificaciones $label ",
          showLegend: "1",
          showPercentValues: "1",
          legendPosition: "bottom",
          useDataPlotColorForLabels: "1",
          enableMultiSlicing: "0",
          theme: "fusion",
          showlegend: "0"
        },
        data: null
      },
      items: [
        {
          path: "/auditoria/",
          label: "auditoria"
        },
        {
          path: "/auditoria/notifications-agrupadas",
          label: "Histórico de accesos por documento"
        }
      ],

      listAPI: false,
      loading: true,
      strMonths: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre"
      ],
      tableColumns: [
        {
          prop: "documento",
          label: "Nombre"
        },
        {
          prop: "file",
          type: "file",
          label: "Documento"
        }
      ],
      expandColumns: [
        {
          prop: "name",
          label: "Usuario"
        },
        {
          prop: "fecha",
          type: "date",
          label: "Fecha Aceptación"
        }
      ],
      searchQuery: "",
      deleterow: false,
      limit: 10,
      tableShow: true,
      opentableShowGroup: false,
      tableShowGroup: false,
      tableShow: false,
      opentableShow: false,
      notificationsAPI: false,
      opentableShowChart: false,
      tableShowChart: false,
      max: 0
    };
  },
  methods: {
    toggle(table) {
      this["open" + table] = !this["open" + table];
      this[table] = !this[table];
    },
    async get() {
      ApiService.post("auditoria/all-documents", {
        token: localStorage.getItem("token")
      }).then(response => {
        let d = response.data;
        for (const i of d) {
          i.file = API_UPLOADS + i.file;
        }

        this.listAPI = d;
        this.reloadComponent++;
        this.tableShowGroup = true;
      });
    }
  },
  computed: {
    getList() {
      return this.listAPI;
    }
  }
};
</script>


<style lang="scss" scoped>
.el-breadcrumb {
  margin-bottom: 0 !important;
}
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/auditoria/accessDocumenthistory.vue